
import axios from 'axios';
import { authService } from "../services/auth";

// TODO: enable preview environment url for "production" prview environment
// const BASE_URL = process.env.NODE_ENV === 'production' ? `https://${process.env.REACT_APP_RENDER_API_SERVICE}.onrender.com` : 'http://localhost:8000';
const BASE_URL = process.env.NODE_ENV === 'production' ? `https://a.moonscroll.ai` : 'http://localhost:8000';

const allowed401s = ['/api/token/', '/api/token/refresh/']; // most 401s should take user to /login/. add valid 401s here


// set interceptors to pass auth token if we have it in the local storage
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('accessToken');
    if (token){
      config.headers.authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// if response is 401 and it's not a retry, refresh access token
axios.interceptors.response.use((response) => {
   return response
}, 
function (error) {
  const originalRequest = error.config;
  if (error.response && error.response.status === 401 && !originalRequest._retry && !allowed401s.includes(originalRequest.url.replace(BASE_URL, ''))) {
    originalRequest._retry = true;
    return postRequest(
      '/api/token/refresh/',
      {'refresh': localStorage.getItem('refreshToken')},
      (response) => {
        const accessToken = response.data.access;
        localStorage.setItem('accessToken', accessToken);
        return axios(originalRequest);
      },
      (error) => {
        // 401 on refresh means user is logged out; send to login with return path
        const next = encodeURIComponent(window.location.pathname + window.location.search);
        window.location = `/login/?next=${next}&autologgedout=1`;
      }
    )
  }

  // return Error object with Promise
  return Promise.reject(error);
})


const getRequest = (url, successCallback, errorCallback) => {
  return axios.get(BASE_URL + url)
    .then(response => {
        if (successCallback){
            return successCallback(response)
        }
    })
    .catch((error) => {
      // take user to login if they just made an invalid 401 request
      if (error.response && error.response.status === 401 && !allowed401s.includes(url)){
        window.location = `/login/?next=${window.location.href}`;
      } else {
        if (errorCallback){
          return errorCallback(error)
        }
      }
    });
}

const postRequest = (url, data, successCallback, errorCallback) => {
  return axios.post(BASE_URL + url, data)
    .then((response) => {
        if (successCallback){
            return successCallback(response)
        }
    })
    .catch((error) => {
      // take user to login if they just made an invalid 401 request
      if (error.response && error.response.status === 401 && !allowed401s.includes(url)){
        window.location = `/login/?next=${window.location.href}`;
      } else {
        if (errorCallback){
          return errorCallback(error)
        }
      }
    });
}

const patchRequest = (url, data, successCallback, errorCallback) => {
  return axios.patch(BASE_URL + url, data)
    .then((response) => {
      if (successCallback) {
        return successCallback(response);
      }
    })
    .catch((error) => {
      if (error.response && error.response.status === 401 && !allowed401s.includes(url)) {
        window.location = `/login/?next=${window.location.href}`;
      } else {
        if (errorCallback) {
          return errorCallback(error);
        }
      }
    });
};

const deleteRequest = (url, successCallback, errorCallback) => {
  return axios.delete(BASE_URL + url)
    .then((response) => {
      if (successCallback){
          return successCallback(response)
      }
    })
    .catch((error) => {
      // take user to login if they just made an invalid 401 request
      if (error.response && error.response.status === 401 && !allowed401s.includes(url)){
        window.location = `/login/?next=${window.location.href}`;
      } else {
        if (errorCallback){
          return errorCallback(error)
        }
      }
    });
}

export {
  BASE_URL,
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
}